import request from '@/utils/request'

/**
* 系统日志表API
*
* @author Ych Tu
* @since 2023/02/02
*/

/**
* 基础接口
*
* @type {string}
*/
const BASE_URL = '/syslog/sysLog'



/**
* 分页查询接口
*
* @type {string}
*/
export const PAGE_URL = `${BASE_URL}/page`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id:number) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}
